import React from 'react';
import { NotificationConfig, NotificationType, Theme } from '@routific/hive';
import i18n from '../../i18n';

/**
 * Unpublished planner changes on a route were discarded because the driver finished it.
 * Info, not a warning: the route completed normally, and the planner needs to know the
 * pending edits are gone. Hive drops a caller's `description` and replaces it with the
 * link, so the two lines ride on `message` and View route is `linkMessage`.
 */
export const unpublishedChangesDiscardedNotification = (
  routeUuid: string,
  driverName: string | undefined,
  onViewRoute: () => void,
): NotificationConfig => ({
  id: `route-unpublished-changes-discarded-${routeUuid}`,
  type: NotificationType.INFO,
  message: (
    <>
      <div>
        {driverName
          ? i18n.t('notifications:editRoute.unpublishedChangesDiscarded.title', { driverName })
          : i18n.t('notifications:editRoute.unpublishedChangesDiscarded.titleUnnamed')}
      </div>
      <div style={{
        ...Theme.Typography.Caption.toObject(),
        color: Theme.Colors.textSecondary,
        marginTop: Theme.Spacing.xsSpacing,
      }}
      >
        {i18n.t('notifications:editRoute.unpublishedChangesDiscarded.message')}
      </div>
    </>
  ),
  linkMessage: i18n.t('notifications:editRoute.unpublishedChangesDiscarded.viewRoute'),
  linkOnClick: onViewRoute,
  dataCy: 'route-unpublished-changes-discarded-notification',
});
